const DEFAULT_VOLUME = 0.45;

export class AudioManager {
  private audio: HTMLAudioElement;
  private muted = true;
  private listeners = new Set<(muted: boolean) => void>();

  constructor(src: string) {
    this.audio = new Audio(src);
    this.audio.loop = true;
    this.audio.preload = "auto";
    this.audio.volume = DEFAULT_VOLUME;
    this.audio.muted = true;
  }

  isMuted(): boolean {
    return this.muted;
  }

  toggle(): boolean {
    this.setMuted(!this.muted);
    return this.muted;
  }

  setMuted(muted: boolean) {
    if (muted === this.muted) return;
    this.muted = muted;
    this.audio.muted = muted;
    if (!muted && this.audio.paused) {
      this.audio.play().catch(() => {});
    }
    for (const cb of this.listeners) cb(muted);
  }

  onChange(cb: (muted: boolean) => void) {
    this.listeners.add(cb);
  }
}
